import { Box } from '@chakra-ui/react'
import { useRouter } from 'next/router'

import { makeServerProps } from '@/server/query'

import { PageNotFoundError } from '@/client/error'
import {
  BLOG_ARTICLE_CATEGORIES,
  BLOG_ARTICLE_CATEGORY_TO_LABEL,
  type BlogArticleCategory,
  DEFAULT_BLOG_PAGE_SIZE,
} from '@/client/services/blog'
import makePage from '@/client/services/pages/makePage'

import BlogArticleList from '@/components/Blog/BlogArticleList'
import BlogHeader from '@/components/Blog/BlogHeader'
import useBlogArticles from '@/components/Blog/hooks/useBlogArticles'
import Layout from '@/components/Layout/Layout'
import { useInfiniteScroll } from '@/components/Session/helpers'
import Container from '@/components/Worlds/UI/Container/Container'

function BlogIndex() {
  const router = useRouter()

  const [queryLimit, handleLoadMore] = useInfiniteScroll({ defaultValue: DEFAULT_BLOG_PAGE_SIZE })

  const queryCategory = `${router.query.category}`

  if (!BLOG_ARTICLE_CATEGORIES.map(c => `${c}`).includes(queryCategory)) {
    throw new PageNotFoundError()
  }

  const category = queryCategory as BlogArticleCategory

  const { blogArticles: pinnedBlogArticles } = useBlogArticles({ category, pinnedTo: 'category' })
  const { blogArticles, countTotalItems } = useBlogArticles({ category, limit: queryLimit })

  return (
    <Layout title="Schoolhouse Blog">
      <Container>
        <BlogHeader currentTab={BLOG_ARTICLE_CATEGORY_TO_LABEL[category]} />
        {pinnedBlogArticles.length === 0 ? null : (
          <Box mb="36px">
            <BlogArticleList
              blogArticles={pinnedBlogArticles}
              columns={1}
              pinnedToContext="category"
            />
          </Box>
        )}
        <BlogArticleList
          blogArticles={blogArticles.filter(article => article.pinnedTo !== 'category')}
          infiniteScrollConfig={{ queryLimit, handleLoadMore, countTotalItems }}
        />
      </Container>
    </Layout>
  )
}

const BlogIndexPage = makePage(BlogIndex, {
  blockedUsers: 'allowed',
  onboardingUsers: 'allowed',
})

export const getServerSideProps = makeServerProps(BlogIndexPage)
export default BlogIndexPage
